// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend-module__legend___31aWw","legendItem":"Legend-module__legendItem___3G6Es","legendItemIcon":"Legend-module__legendItemIcon___2Hb0_"};